import { Box, Button, Input, SlideFade, Text } from '@chakra-ui/react'
import { CirclePlusIcon } from '../../assets/CirclePlusIcon'
import { useTranslation } from 'react-i18next'
import { TrashIcon } from '../../assets/TrashIcon'

const RedButtonEmails = ({
	emails,
	setEmails,
}: {
	emails: { tempId: string; email: string }[]
	setEmails: (emails: { tempId: string; email: string }[]) => void
}) => {
	const { t } = useTranslation()

	return (
		<Box
			bg='#F5F8FA'
			p={'21px'}
			rounded='10px'
		>
			<SlideFade in>
				<Box
					width={'100%'}
					display='flex'
					justifyContent={'space-between'}
					alignItems='center'
					mb={'7px'}
				>
					<Text
						fontSize={'22px'}
						fontWeight='600'
					>
						{t('modifyCompany.red-button.emails')}
					</Text>
					<div className='flex gap-4'>
						<Button
							minW={'188px'}
							textAlign='center'
							fontSize='18px'
							fontWeight={700}
							rounded={'100px'}
							borderWidth={'1.5px'}
							borderColor={'#3FB2D2'}
							bg={'transparent'}
							color={'#3FB2D2'}
							onClick={() => {
								setEmails([
									...emails,
									{
										tempId: (Math.random() + 1).toString(36).substring(2),
										email: '',
									},
								])
							}}
						>
							<Box
								gap={'17px'}
								display={'flex'}
								alignItems={'center'}
							>
								<Text>{t('modifyCompany.red-button.addEmail')}</Text>
								<CirclePlusIcon />
							</Box>
						</Button>
					</div>
				</Box>
				<div className='flex flex-col gap-4 mt-4'>
					{emails.map(({ email, tempId }) => (
						<div
							key={tempId}
							className='flex items-center justify-between gap-4'
						>
							<Input
								placeholder={t('modifyCompany.red-button.email')}
								borderColor='#E2E2E2'
								type='email'
								bg='white'
								fontSize='16px'
								fontWeight={400}
								paddingInline='12px'
								value={email}
								onChange={(event) => {
									setEmails(
										emails.map((e) =>
											e.tempId === tempId ? { ...e, email: event.target.value } : e
										)
									)
								}}
							/>
							<Button
								onClick={() => {
									setEmails(emails.filter((e) => e.tempId !== tempId))
								}}
								colorScheme='red'
								variant='outline'
								borderColor='#E2E2E2'
								borderWidth='1px'
								bg='white'
								color='#E53E3E'
								_hover={{ bg: '#F5F8FA' }}
							>
								<TrashIcon />
							</Button>
						</div>
					))}
				</div>
			</SlideFade>
		</Box>
	)
}

export default RedButtonEmails
